// // import jsPDF from "jspdf";
// // import "jspdf-autotable";
// // import moment from "moment";

// // export const generatePDF = (data) => {
// //   const doc = new jsPDF();
// //   let yPos = 10;

// //   data.questionsDetails.forEach((question, index) => {
// //     // **Check Page Height - Add New Page If Needed**
// //     if (yPos > 250) {
// //       doc.addPage();
// //       yPos = 10;
// //     }

// //     // **Viewer Details Header**
// //     doc.setFont("helvetica", "bold");
// //     doc.setFontSize(10);
// //     doc.text(`Name: ${question.viewerDetails.viewerName || "N/A"}`, 10, yPos);
// //     doc.text(
// //       `Company: ${question.viewerDetails.viewerCompanyName || "N/A"}`,
// //       70,
// //       yPos,
// //     );
// //     doc.text(
// //       `Email: ${question.viewerDetails.viewerEmail || "N/A"}`,
// //       150,
// //       yPos,
// //     );

// //     // **Date Formatting**
// //     doc.setFontSize(9);
// //     doc.setTextColor(100);
// //     // doc.text(moment(question.sendDate).format("MMMM DD, YYYY"), 180, yPos, {
// //     //   align: "right",
// //     // });

// //     yPos += 8;

// //     // **Question Formatting**
// //     doc.setFontSize(11);
// //     doc.setFont("helvetica", "bold");
// //     doc.setTextColor(0);
// //     doc.text("Question:", 10, yPos);
// //     yPos += 6;
// //     doc.setFont("helvetica", "normal");
// //     doc.text(question.messageText, 10, yPos, { maxWidth: 180 });
// //     yPos += 8;

// //     // **Answers Section**
// //     if (question.answerDetails.length > 0) {
// //       const answersData = question.answerDetails.map((answer, idx) => [
// //         idx + 1,
// //         answer.messageText,
// //         moment(answer.sendDate).format("DD MMM YYYY, hh:mm A"),
// //       ]);

// //       // **Use AutoTable for Answers**
// //       doc.autoTable({
// //         startY: yPos,
// //         head: [["#", "Answer", "Date"]],
// //         body: answersData,
// //         styles: { fontSize: 9, cellWidth: "wrap" },
// //         columnStyles: {
// //           0: { cellWidth: 10 }, // Number column
// //           1: { cellWidth: 120 }, // Answer text
// //           2: { cellWidth: 50 }, // Date column
// //         },
// //       });

// //       yPos = doc.lastAutoTable.finalY + 10;
// //     } else {
// //       doc.text("No answers yet", 10, yPos);
// //       yPos += 6;
// //     }

// //     // **Separator Line Between Questions**
// //     if (index < data.questionsDetails.length - 1) {
// //       doc.setDrawColor(200);
// //       doc.line(10, yPos + 2, 200, yPos + 2);
// //       yPos += 10;
// //     }
// //   });

// //   // **Save the PDF**
// //   doc.save("questions_report.pdf");
// // };

// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import moment from "moment";
// import { Images } from "../../../assets/images";

// // Sample Base64 Images (Replace with your actual Base64 strings)
// const headerImage = Images.companyLogo; // Replace with actual Base64
// const footerImage = Images.companyLogo; // Replace with actual Base64

// export const generatePDF = (data, status) => {
//   const doc = new jsPDF();

//   const header = () => {
//     if (headerImage) {
//       doc.addImage(headerImage, "PNG", 10, 5, 40, 15); // (image, format, x, y, width, height)
//     }

//     doc.setFont("helvetica", "bold");
//     doc.setFontSize(14);
//     doc.text("Event Report", 70, 15);

//     doc.setFontSize(11);
//     doc.text(`Event: ${data.eventDetails.name}`, 10, 30);
//     doc.text(`Description: ${data.eventDetails.description}`, 10, 36);

//     doc.setDrawColor(100);
//     doc.line(10, 40, 200, 40);
//   };

//   const footer = () => {
//     const pageCount = doc.internal.getNumberOfPages();
//     for (let i = 1; i <= pageCount; i++) {
//       doc.setPage(i);

//       if (footerImage) {
//         doc.addImage(footerImage, "PNG", 85, 280, 40, 10);
//       }

//       doc.setFontSize(9);
//       doc.setTextColor(100);
//       doc.text(`Page ${i} of ${pageCount}`, 190, 290, { align: "right" });
//       doc.text(
//         `Generated on: ${moment().format("DD MMM YYYY, hh:mm A")}`,
//         10,
//         290,
//       );
//     }
//   };

//   let yPos = 50;
//   header();

//   data.questionsDetails.forEach((question, index) => {
//     if (yPos > 250) {
//       doc.addPage();
//       yPos = 50;
//       header();
//     }

//     // **Viewer Details Header**
//     doc.setFont("helvetica", "bold");
//     doc.setFontSize(10);
//     doc.text(`Name: ${question.viewerDetails.viewerName || "N/A"}`, 10, yPos);
//     doc.text(
//       `Company: ${question.viewerDetails.viewerCompanyName || "N/A"}`,
//       70,
//       yPos,
//     );
//     doc.text(
//       `Email: ${question.viewerDetails.viewerEmail || "N/A"}`,
//       150,
//       yPos,
//     );

//     yPos += 8;

//     /*

//     // **Date Formatting**
//     doc.setFontSize(9);
//     doc.setTextColor(100);
//     doc.text(
//       `Date: ${moment(question.sendDate).format("MMMM DD, YYYY")}`,
//       180,
//       yPos,
//       {
//         align: "right",
//       },
//     );

//     yPos += 8;

//     */

//     doc.setFont("helvetica", "bold");
//     doc.setFontSize(11);
//     doc.text(`Q${index + 1}: ${question.messageText}`, 10, yPos, {
//       maxWidth: 180,
//     });

//     yPos += 8;

//     if (question.answerDetails.length > 0) {
//       const answersData = question.answerDetails.map((answer, idx) => [
//         idx + 1,
//         answer.messageText,
//         moment(answer.sendDate).format("DD MMM YYYY, hh:mm A"),
//       ]);

//       doc.autoTable({
//         startY: yPos,
//         head: [["S.no", "Answer", "Date"]],
//         body: answersData,
//         styles: { fontSize: 9 },
//         columnStyles: {
//           0: { cellWidth: 12 },
//           1: { cellWidth: 120 },
//           2: { cellWidth: 50 },
//         },
//       });

//       yPos = doc.lastAutoTable.finalY + 10;
//     } else {
//       doc.setFontSize(10);
//       doc.text("No answers yet", 10, yPos);
//       yPos += 8;
//     }

//     if (index < data.questionsDetails.length - 1) {
//       doc.setDrawColor(200);
//       doc.line(10, yPos, 200, yPos);
//       yPos += 10;
//     }
//   });

//   footer();

//   if (status === "download") {
//     doc.save("Q and A report.pdf");
//   } else {
//     const pdfBlob = doc.output("blob");

//     // **Create Blob URL**
//     const pdfUrl = URL.createObjectURL(pdfBlob);

//     // **Open in a New Tab**
//     const newTab = window.open(pdfUrl, "_blank");

//     if (newTab) {
//       // **Wait for the tab to load, then trigger print**
//       setTimeout(() => {
//         newTab.print();
//       }, 500);
//     } else {
//       alert("Please allow popups to print the document.");
//     }
//   }
// };

import { saveAs } from "file-saver";
import {
  Document,
  Packer,
  Paragraph,
  TextRun,
  Table,
  TableRow,
  TableCell,
  WidthType,
  Header,
  Footer,
  ImageRun,
  AlignmentType,
} from "docx";
import moment from "moment";

// Import images (Convert to Base64 if using local images)
import { Images } from "../../../assets/images";

export const generateDOCX = async (data, status) => {
  // Convert Image to Base64 (if not already)
  const imageToBase64 = async (imagePath) => {
    const response = await fetch(imagePath);
    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result.split(",")[1]); // Get base64 content
      reader.readAsDataURL(blob);
    });
  };

  const headerBase64 = await imageToBase64(Images.companyLogo);
  const footerBase64 = await imageToBase64(Images.companyLogo);

  const doc = new Document({
    sections: [
      {
        properties: {},
        headers: {
          default: new Header({
            children: [
              new Paragraph({
                children: [
                  new ImageRun({
                    data: Buffer.from(headerBase64, "base64"),
                    transformation: { width: 100, height: 40 },
                  }),
                ],
              }),
            ],
          }),
        },
        footers: {
          default: new Footer({
            children: [
              new Paragraph({
                alignment: "center",
                children: [
                  new ImageRun({
                    data: Buffer.from(footerBase64, "base64"),
                    transformation: { width: 100, height: 40 },
                  }),
                ],
              }),
              // new Paragraph({
              //   text: `Generated on: ${moment().format(
              //     "DD MMM YYYY, hh:mm A",
              //   )}`,
              //   alignment: "center",
              // }),
            ],
          }),
        },
        children: [
          // Event Title
          new Paragraph({
            alignment: AlignmentType.CENTER,
            children: [
              new TextRun({ text: "Event Report", bold: true, size: 28 }),
            ],
          }),
          new Paragraph({
            text: `Event: ${data.eventDetails.name}`,
            bold: true,
            spacing: { before: 200, after: 100 },
          }),
          new Paragraph({
            text: `Description: ${data.eventDetails.description}`,
            spacing: { after: 300 },
          }),

          // Loop through questions
          ...data.questionsDetails.flatMap((question, index) => [
            new Paragraph({
              children: [
                new TextRun({
                  text: `Q${index + 1}: ${question.messageText}`,
                  bold: true,
                  size: 24,
                }),
              ],
              spacing: { after: 200 },
            }),

            // Viewer Details
            new Paragraph({
              children: [
                new TextRun({
                  text: `Name: ${
                    question.viewerDetails.viewerName || "N/A"
                  } | `,
                  bold: true,
                }),
                new TextRun({
                  text: `Company: ${
                    question.viewerDetails.viewerCompanyName || "N/A"
                  } | `,
                }),
                new TextRun({
                  text: `Email: ${question.viewerDetails.viewerEmail || "N/A"}`,
                }),
              ],
              spacing: { after: 100 },
            }),

            // Answers Table (if available)
            question.answerDetails.length > 0
              ? new Table({
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [new Paragraph("S.No")],
                          width: { size: 10, type: WidthType.PERCENTAGE },
                        }),
                        new TableCell({
                          children: [new Paragraph("Answer")],
                          width: { size: 60, type: WidthType.PERCENTAGE },
                        }),
                        new TableCell({
                          children: [new Paragraph("Date")],
                          width: { size: 30, type: WidthType.PERCENTAGE },
                        }),
                      ],
                    }),
                    ...question.answerDetails.map(
                      (answer, idx) =>
                        new TableRow({
                          children: [
                            new TableCell({
                              children: [new Paragraph(`${idx + 1}`)],
                            }),
                            new TableCell({
                              children: [new Paragraph(answer.messageText)],
                            }),
                            new TableCell({
                              children: [
                                new Paragraph(
                                  moment(answer.sendDate).format(
                                    "DD MMM YYYY, hh:mm A",
                                  ),
                                ),
                              ],
                            }),
                          ],
                        }),
                    ),
                  ],
                })
              : new Paragraph({
                  text: "No answers yet.",
                  italic: true,
                  spacing: { after: 300 },
                }),

            // Line break between questions
            new Paragraph({ text: "", spacing: { after: 300 } }),
          ]),
        ],
      },
    ],
  });

  // Generate and Download DOCX File

  if (status === "download") {
    Packer.toBlob(doc).then((blob) => {
      saveAs(blob, "Q and A Report.docx");
    });
    // doc.save("Q and A report.pdf");
  } else {
    const blob = await Packer.toBlob(doc);
    saveAs(blob, "Q and A Report.docx");

    // Open the file after download (this requires user interaction)
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank"); // Opens in a new tab
  }
};
